var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "div",
        { staticClass: "section-wrapper w-100" },
        [
          _vm.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES
            ? [
                _c(
                  "b-card",
                  {
                    attrs: { id: "commission-record-card" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "b-row",
                                {
                                  staticClass:
                                    "align-items-end justify-content-between",
                                },
                                [
                                  _c("b-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "direct-to-lender.commissions.sectionNames.commission-record"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex justify-content-end",
                                      attrs: { cols: "6" },
                                    },
                                    [
                                      _c("mortgage-selector", {
                                        attrs: {
                                          mortgage:
                                            _vm.currentCommissionsMortgageType,
                                          "disabled-mortgages":
                                            _vm.disabledMortgages,
                                        },
                                        on: {
                                          "update:mortgage":
                                            _vm.handleChangeMortgageType,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      184381097
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("commission-record-container", {
                      attrs: {
                        "current-commissions-mortgage-type":
                          _vm.currentCommissionsMortgageType,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  {
                    attrs: { id: "fees-card", "no-body": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "b-row",
                                { staticClass: "align-items-end" },
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "direct-to-lender.commissions.sectionNames.fees"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "footer",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-primary bold" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "direct-to-lender.commissions.fees.totalFees"
                                            )
                                          ) +
                                          ":\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bold ml-1" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("formatMoneyValueLong")(
                                            _vm.totalFeesAmount
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.loadingTotalCommissionFees
                                    ? _c(
                                        "span",
                                        [
                                          _c("inline-loader", {
                                            staticClass: "mx-2",
                                            attrs: {
                                              width: "16px",
                                              height: "16px",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      215888377
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("fees-container", {
                      attrs: {
                        "application-id": _vm.applicationId,
                        "client-username": _vm.clientUsername,
                        "current-commissions-mortgage-type":
                          _vm.currentCommissionsMortgageType,
                        "is-read-only": _vm.isReadOnly,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("commission-deductions-container", {
                  attrs: {
                    "client-username": _vm.clientUsername,
                    "application-id": _vm.applicationId,
                    "current-commissions-mortgage-type":
                      _vm.currentCommissionsMortgageType,
                    "is-read-only": _vm.isReadOnly,
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-card",
                  {
                    attrs: { id: "commission-details-card" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "b-row",
                                { staticClass: "align-items-end" },
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "direct-to-lender.commissions.sectionNames.commission-details"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      808623557
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("commission-details-container", {
                      attrs: {
                        "application-id": _vm.applicationId,
                        "client-username": _vm.clientUsername,
                        "agent-username": _vm.agentUsername,
                        "mortgage-type": _vm.currentCommissionsMortgageType,
                        loading: _vm.loadingDetails,
                        "is-read-only": _vm.isReadOnly,
                      },
                      on: {
                        "update:loading": function ($event) {
                          _vm.loadingDetails = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  {
                    attrs: { id: "notes-card" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "b-row",
                                { staticClass: "align-items-end" },
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "direct-to-lender.commissions.sectionNames.notes"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2756571556
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("notes-container", {
                      attrs: {
                        "application-id": _vm.applicationId,
                        "client-username": _vm.clientUsername,
                        "mortgage-type": _vm.currentCommissionsMortgageType,
                        loading: _vm.loadingDetails,
                        "is-read-only": _vm.isReadOnly,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "align-items-center justify-content-center",
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "no-results",
                            {
                              attrs: {
                                "img-src": require("@Shared/@Assets/img/application-missing.png"),
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "global.messages.youNeedToFillOutMortgageDetailsFirst"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "auto" } }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.goToMortgageDetails },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "internal-notes.actions.clickHereToFillThem"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES
        ? _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end my-3",
              attrs: { cols: "12" },
            },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    text: _vm.$t("global.words.print"),
                    type: "primary",
                    "class-name": "btn-sm",
                    loading: _vm.loadingPrint,
                    "loading-succeeded": _vm.loadingPrintSucceeded,
                  },
                  on: { click: _vm.printCommissions },
                },
                [
                  _c("icon", { attrs: { name: "folder-open-o" } }),
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("global.words.print")) + "\n    "
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }